import { observer } from 'mobx-react-lite';
import RoundedButton from '../../Globle/RoundedButton';
import { DetailsIcon, ProjectIcon, StyleIcon } from '../../Globle/Icon';
import { useEffect, useState } from 'react';
import { IoIosArrowForward } from 'react-icons/io';
import { Form, message } from 'antd';
import ProjectDetails from './ProjectDetails';
import {
    ClosetColor,
    DoorColor,
    DoorStyle,
    DrawerColor,
    HandleColor,
    HandleStyle,
    ProjectScope,
    RodColor,
} from '../../../config';
import ClosetStyle from './ClosetStyle';
import { useMainContext } from '../../../hooks/useMainContext';
import StartingPointModel from './StartingPointModel';
import PdfUploadModel from './PdfUploadModel';
import { extractName } from '../../../utils/uiUtils';

const ProjectForm = observer(() => {
    const { uiManager, viewManager } = useMainContext();
    const [form] = Form.useForm();
    const [selectedTab, setSelectedTab] = useState('details');
    const [isStyleTabDisabled, setIsStyleTabDisabled] = useState(true);
    const projectName = Form.useWatch('projectName', form);
    const projectCreator = Form.useWatch('projectCreator', form);
    const projectScope = Form.useWatch('projectScope', form);
    const customScope = Form.useWatch('customScope', form);
    const buttons = [
        {
            icon: <DetailsIcon />,
            label: 'Details',
            key: 'details',
            disabled: false,
        },
        {
            icon: <StyleIcon />,
            label: 'Style',
            key: 'style',
            disabled: isStyleTabDisabled,
        },
    ];

    useEffect(() => {
        const validateRequiredFields = () => {
            // Check basic required fields
            const hasName = !!projectName?.trim();
            const hasCreator = !!projectCreator?.trim();
            const hasScope = !!projectScope;

            // Additional check for custom scope
            const needsCustomScope = projectScope === ProjectScope.CUSTOM;
            const hasCustomScope = needsCustomScope
                ? !!customScope?.trim()
                : true;

            // Enable style tab only if all conditions are met
            setIsStyleTabDisabled(
                !(hasName && hasCreator && hasScope && hasCustomScope),
            );
        };

        validateRequiredFields();
    }, [projectName, projectCreator, projectScope, customScope]);
    const handleNext = async () => {
        setSelectedTab('style');
    };
    const handleProjectSetup = async () => {
        try {
            const values = await form.validateFields(); // Will throw if invalid
            viewManager.setFormData(values);
            uiManager.setIsStartingPoint(true);
        } catch (error) {
            message.error('Please fill in all required fields.');
        }
    };

    return (
        <>
            <div className="w-full flex gap-[16px] h-full p-[16px]">
                <div className="w-[320px] p-[24px] bg-theme-white rounded-[20px] h-fit">
                    <div className="flex items-center gap-[8px] mb-[24px]">
                        <RoundedButton
                            icon={<ProjectIcon />}
                            title="Project"
                            className="w-[48px] h-[48px]   project-button "
                            disabled={true}
                        />
                        <h1 className="font-favorit text-[20px] font-[700] leading-[28px] text-theme-black">
                            Project Information
                        </h1>
                    </div>
                    <div className="flex flex-col gap-[8px]  ">
                        {buttons.map((item, index) => (
                            <button
                                key={index}
                                disabled={item.disabled}
                                className={`rounded-[8px] w-full h-[48px] flex justify-between items-center px-[16px] py-[12px] project-side-button ${selectedTab === item.key ? 'active-btn' : ''} `}
                                onClick={() => setSelectedTab(item.key)}>
                                <div className="flex gap-[8px] items-center justify-center">
                                    <span>{item.icon}</span>
                                    <span className="text-[16px] font-favorit font-[400] leading-[20px]">
                                        {item.label}
                                    </span>
                                </div>
                                {selectedTab === item.key && (
                                    <IoIosArrowForward className="w-[24px] h-[24px] text-theme-black" />
                                )}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="flex-1 bg-theme-white rounded-[20px] h-full p-[32px]">
                    <Form
                        form={form}
                        layout="vertical"
                        requiredMark={false}
                        initialValues={{
                            projectName: '',
                            projectDescription: '',
                            projectCreator: viewManager.userData.name
                                ? viewManager.userData.name
                                : extractName(viewManager.userData.email),
                            projectScope: ProjectScope.ALL_CLOSETS,
                            customScope: undefined,
                            color: ClosetColor.WHITE,
                            handleStyle: HandleStyle.T_BAR,
                            handleColor: HandleColor.CHROME,
                            rodColor: RodColor.CHROME,
                            doorColor: DoorColor.WHITE,
                            drawerColor: DrawerColor.WHITE,
                            drawerStyle: DoorStyle.SLAB,
                            doorStyle: DoorStyle.SLAB,
                            legs: false,
                            shelf: false,
                            topDoors: false,
                            bottomDoors: false,
                        }}>
                        <div
                            style={{
                                display:
                                    selectedTab === 'details'
                                        ? 'block'
                                        : 'none',
                            }}>
                            <ProjectDetails
                                Form={Form}
                                form={form}
                                isStyleTabDisabled={isStyleTabDisabled}
                                onNext={handleNext}
                            />
                        </div>

                        <div
                            style={{
                                display:
                                    selectedTab === 'style' ? 'block' : 'none',
                            }}>
                            <ClosetStyle
                                Form={Form}
                                form={form}
                                onNext={handleProjectSetup}
                            />
                        </div>
                    </Form>
                </div>
            </div>
            <StartingPointModel />
        </>
    );
});

export default ProjectForm;
